// extracted by mini-css-extract-plugin
export var container = "ImageBleedCallout-module--container--87a96";
export var content = "ImageBleedCallout-module--content--afe30";
export var image = "ImageBleedCallout-module--image--3d881";
export var imageBleedCallout = "ImageBleedCallout-module--image-bleed-callout--80ed5";